<lib-trivia-page [setId]="id"></lib-trivia-page>